import { render, staticRenderFns } from "./SYTradeList.vue?vue&type=template&id=046d16fa&scoped=true&"
import script from "./SYTradeList.vue?vue&type=script&lang=js&"
export * from "./SYTradeList.vue?vue&type=script&lang=js&"
import style0 from "./SYTradeList.vue?vue&type=style&index=0&id=046d16fa&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "046d16fa",
  null
  
)

export default component.exports